import { render, staticRenderFns } from "./recommendConditionDialog.vue?vue&type=template&id=38f38cad&scoped=true"
import script from "./recommendConditionDialog.vue?vue&type=script&lang=js"
export * from "./recommendConditionDialog.vue?vue&type=script&lang=js"
import style0 from "./recommendConditionDialog.vue?vue&type=style&index=0&id=38f38cad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f38cad",
  null
  
)

export default component.exports